<template>
<div id="workreport">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClickTabs" style="margin: auto" lazy>

        <el-tab-pane label="日" name="日">
            <workDay v-if=" onoffText === '日' "></workDay>
        </el-tab-pane>

        <el-tab-pane label="周" name="周">
            <workWeek  v-if=" onoffText === '周' "></workWeek>
        </el-tab-pane>

        <el-tab-pane label="月" name="月">
            <workMonth v-if=" onoffText === '月' "></workMonth>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>

    import workDay from './components/workreportday'
    import workWeek from './components/workreportweek'
    import workMonth from './components/workreportmonth'
    export default {
        name: "workreport",
        data(){
            return {
                activeName:'日',
                value1:'',
                onoffText:'日'
            }
        },
        components:{
            workDay,
            workWeek,
            workMonth
        },
        methods:{
            handleClickTabs(item){
                if (item.name === '日') {
                    this.onoffText='日'
                }else if (item.name === '周') {
                    this.onoffText='周'
                }else if (item.name === '月') {
                    this.onoffText='月'
                }
            }
        }
    }
</script>

<style scoped>
    #workreport >>> .el-tabs__nav-scroll{
        position: relative;
        height: 50px;
    }
    #workreport >>> .el-tabs__nav{
        display: block;
        position: absolute;
        border: 1px solid transparent;
        left: 50%;
        margin-left: -174px;
    }
    #workreport >>> .el-tabs__header{
        border-bottom: none;
    }
    #workreport >>> .el-tabs__item{
        border: 1px solid #DCDFE6;
        padding-left: 50px;
        padding-right: 50px;
    }
    #workreport >>> .is-active{
        color: #409EFF;
        border: 1px solid #c6e2ff;
        background-color: #ecf5ff;
    }
    #workreport >>> .el-tabs__item:first-child{
        border-radius: 4px 0 0 4px;
    }
    #workreport >>> .el-tabs__item:nth-of-type(2){
        border-left: none;
        border-right: none;
    }
    #workreport >>> .el-tabs__item:last-child{
        border-radius: 0px 4px 4px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/workreport/workreport.vue